import { getDeviceInfo } from '@sitebase/device-detector';

export const getClassByDevice = () => {
  const deviceInfo = getDeviceInfo();

  return deviceInfo.isDesktop
    ? 'isDesktop'
    : deviceInfo.isTablet
      ? 'isTablet'
      : deviceInfo.isNative
        ? 'isNative'
        : 'isMobile';
};

export const getCookie = (name: string): string | null =>
  document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'))?.[2] ?? null;

export const checkNativeActionSupport = (action: string) =>
  !!(
    window.ActionWebInterface?.supportedActions?.().includes(action) ||
    window.WH.supportedNativeActions?.includes?.(action)
  );

export const hideNativeComponents = () => {
  if (!checkNativeActionSupport('hideNativeComponent')) {
    return;
  }

  window.ActionWebInterface?.doAction(
    'hideNativeComponent',
    JSON.stringify(['stories', 'carousel']),
  );
};

export const showNativeComponents = () => {
  if (!checkNativeActionSupport('showNativeComponent')) {
    return;
  }

  window.ActionWebInterface?.doAction(
    'showNativeComponent',
    JSON.stringify(['stories', 'carousel']),
  );
};

export { getDeviceInfo };
